import { Injector } from '@angular/core'

import {
  FlxModalComponentType,
  FlxModalConfig,
  FlxModalData,
  FlxModalRef,
  FlxModalService,
} from '@flowx/angular-ui-toolkit'

const MODAL_AI_ZINDEX = `z-[1010]`

export function showAiModal(
  modalService: FlxModalService,
  component: FlxModalComponentType,
  config: FlxModalConfig = {},
  data: FlxModalData = {},
  componentInjector: Injector = undefined
): FlxModalRef {
  return modalService.show(
    component,
    {
      ...config,
      hostClass: `${MODAL_AI_ZINDEX} ${config.hostClass ?? ''}`.trim(),
      panelClass: `${MODAL_AI_ZINDEX} ${config.panelClass ?? ''}`.trim(),
      backdropClass: `${MODAL_AI_ZINDEX} ${config.backdropClass ?? ''}`.trim(),
    },
    data,
    componentInjector
  )
}
